import { h } from '../dom.js';
import type { Series, Course } from '../types.js';
import { navigate, back } from '../router.js';

export function CourseList(series: Series, currentCourseId: string | null = null): HTMLElement {
  const chapters = series.chapters
    ?? [{ id: '__flat__', title: '', courses: series.courses ?? [] }];

  const totalCourses = chapters.reduce((n, c) => n + c.courses.length, 0);

  return h('section', { className: 'course-view' }, [
    h('header', { className: 'view-header view-header--tight' }, [
      h('button', {
        className: 'icon-btn',
        attrs: { type: 'button', 'aria-label': '返回' },
        on: { click: () => back() },
        text: '←',
      }),
      h('div', { className: 'view-header__body' }, [
        h('h1', { className: 'view-title', text: series.title }),
        h('p', { className: 'view-subtitle', text: chapters[0]?.id === '__flat__'
          ? `${totalCourses} 课`
          : `${chapters.length} 章 · ${totalCourses} 课` }),
      ]),
    ]),
    h('div', { className: 'course-list' }, chapters.map((ch) => renderChapter(series, ch, currentCourseId))),
  ]);
}

function renderChapter(series: Series, chapter: { id: string; title: string; courses: Course[] }, currentCourseId: string | null): HTMLElement {
  const isFlat = chapter.id === '__flat__';
  return h('div', { className: 'chapter' + (isFlat ? ' chapter--flat' : '') }, [
    !isFlat ? h('div', { className: 'chapter__title', text: chapter.title }) : null,
    h('ul', { className: 'chapter__list' }, chapter.courses.map((c) => renderRow(series, c, currentCourseId))),
  ]);
}

function renderRow(series: Series, c: Course, currentCourseId: string | null): HTMLElement {
  const active = c.id === currentCourseId;
  return h(
    'li',
    {
      className: 'course-row' + (active ? ' course-row--active' : ''),
      on: {
        click: () => navigate({ name: 'course', seriesId: series.id, courseId: c.id }),
      },
      attrs: { role: 'button', tabindex: 0 },
    },
    [
      h('div', { className: 'course-row__body' }, [
        h('div', { className: 'course-row__head' }, [
          h('span', { className: 'course-row__id', text: c.title }),
          c.topic ? h('span', { className: 'course-row__topic-title', text: c.topic.title, attrs: { title: c.topic.title } }) : null,
        ]),
      ]),
    ],
  );
}
